const University_Logo_Model = [
  {
    Name: "Abertay University",
    Logo134x64: "/assets/img/University_logo/Abertay_University.jpg",
    Id: "60",
  },

  {
    Name: "Arden University",
    Logo134x64: "/assets/img/University_logo/Arden_University.png",
    Id: "957",
  },

  {
    Name: "Australian Institute of Music",
    Logo134x64: "/assets/img/University_logo/Australian_Institute_of_Music.jpg",
    Id: "48",
  },

  {
    Name: "BSBI – Berlin School of Business and Innovation",
    Logo134x64: "/assets/img/University_logo/BSBI.png",
    Id: "728",
  },
  {
    Name: "Business and Hotel Management School - BHMS",
    Logo134x64: "/assets/img/University_logo/BHMS.png",
    Id: "945",
  },
  {
    Name: "CDU",
    Logo134x64: "/assets/img/University_logo/CDU.jpg",
    Id: "15",
  },

  {
    Name: "Central Queensland University",
    Logo134x64: "/assets/img/University_logo/CQU.jpg",
    Id: "17",
  },
  {
    Name: "Charles Sturt University",
    Logo134x64: "/assets/img/University_logo/Charles_Sturt_University.jpg",
    Id: "5",
  },

  {
    Name: "Deakin University",
    Logo134x64: "/assets/img/University_logo/Deakin_University.jpg",
    Id: "31",
  },
  // {
  //   Name: "ECA",
  //   Logo134x64: "/assets/img/University_logo/ECA.jpg",
  //   Id: "",
  // },

  {
    Name: "Ema(Gedu)",
    Logo134x64: "/assets/img/University_logo/Ema(Gedu).jpg",
    Id: "1034",
  },

  {
    Name: "Gisma University of Applied Sciences",
    Logo134x64:
      "/assets/img/University_logo/Gisma_University_of_Applied_Sciences.jpg",
    Id: "956",
  },
  {
    Name: "GBS Malta (Gedu)",
    Logo134x64: "/assets/img/University_logo/GBS_Malta(Gedu).jpg",
    Id: "1035",
  },

  {
    Name: "GBS Dubai (Gedu)",
    Logo134x64: "/assets/img/University_logo/GBS_Dubai(Gedu).jpg",
    Id: "1036",
  },
  {
    Name: "Harper Adams University",
    Logo134x64: "/assets/img/University_logo/Harper_Adams_University.jpg",
    Id: "196",
  },

  {
    Name: "Heriot Watt University",
    Logo134x64: "/assets/img/University_logo/Heriot_Watt_University.jpg",
    Id: "589",
  },
  {
    Name: "James Cook University",
    Logo134x64: "/assets/img/University_logo/James_Cook_University.jpg",
    Id: "20",
  },
  // {
  //   Name: "James Cook University (brisbane)",
  //   Logo134x64: "/assets/img/University_logo/James_Cook_University_(brisbane).jpg",
  // },
  {
    Name: "Kaplan Business School",
    Logo134x64: "/assets/img/University_logo/Kaplan_Business_School.jpg",
    Id: "660",
  },
  {
    Name: "Schiller Business school (Gedu)",
    Logo134x64:
      "/assets/img/University_logo/Schiller_Business_school_(Gedu).jpg",
    Id: "961",
  },
  {
    Name: "The University of Law",
    Logo134x64: "/assets/img/University_logo/The_University_of_Law.jpg",
    Id: "662",
  },
  {
    Name: "Trinity Western University",
    Logo134x64: "/assets/img/University_logo/Trinity_Western_University.jpg",
    Id: "524",
  },
  {
    Name: "University of Europe for Applied Sciences",
    Logo134x64:
      "/assets/img/University_logo/University_of_Europe_for_Applied_Sciences.jpg",
    Id: "925",
  },
  {
    Name: "University of Hull - London",
    Logo134x64: "/assets/img/University_logo/University_of_Hull.jpg",
    Id: "210",
  },

  {
    Name: "University of Northampton",
    Logo134x64: "/assets/img/University_logo/UON.jpg",
    Id: "288",
  },

  {
    Name: "University of South Wales",
    Logo134x64: "/assets/img/University_logo/University_of_South_Wales.jpg",
    Id: "432",
  },
  {
    Name: "Singapore Raffles Music College (SRMC)",
    Logo134x64:
      "/assets/img/University_logo/Singapore_Raffles_Music_College_ (SRMC).jpg",
    Id: "1045",
  },
  {
    Name: "Kingston International College",
    Logo134x64:
      "/assets/img/University_logo/Kingston_International_College.jpg",
    Id: "1044",
  },
  {
    Name: "Heriot watt university- Dubai",
    Logo134x64: "/assets/img/University_logo/heriot_watt_dubai.jpg",
    Id: "589",
  },
];

export const University_Logo_Navitas = [
  {
    Name: "CSU (Navitas) ",
    Logo134x64: "/assets/img/University_logo/Navitas/CSU_Navitas.jpg",
    Id: "5",
  },

  {
    Name: "Western Sydney University (Navitas)",
    Logo134x64:
      "/assets/img/University_logo/Navitas/Western_Sydney_University_Navitas.jpg",
    Id: "1022",
  },
];

export const Univeristy_Logo_ECA = [
  {
    Name: "UNIVERSITY OF SUNSHINE COAST -Adelaide (ECA)",
    Logo134x64:
      "/assets/img/University_logo/ECA/UNIVERSITY_OF_SUNSHINE_COAST_Adelaide_(ECA).jpg",
    Id: "1037",
  },
  // {
  //   Name: "UNIVERSITY OF CANBERRA - Sydney hills (ECA)",
  //   Logo134x64: "/assets/img/University_logo/ECA/UNIVERSITY_OF_CANBERRA_Sydney_hills_(ECA).jpg",
  //   Id: "903",
  // },
  {
    Name: "UNIVERSITY OF TASMANIA -Melbourne, Sydney (ECA)",
    Logo134x64:
      "/assets/img/University_logo/ECA/UNIVERSITY_OF_TASMANIA_Melbourne_Sydney_(ECA).jpg",
    Id: "903",
  },
  {
    Name: "VICTORIA UNIVERSITY (ECA)",
    Logo134x64:
      "/assets/img/University_logo/ECA/VICTORIA_UNIVERSITY_SYDNEY_(ECA).jpg",
    Id: "600",
  },

  // {
  //   Name: "Victoria University Brisbane (ECA)",
  //   Logo134x64: "/assets/img/University_logo/ECA/Victoria_University_Brisbane_(ECA).jpg",
  //   Id: "600",
  // },
  {
    Name: "SWINBURNE UNIVERSITY OF TECHNOLOGY - Sydney (ECA)",
    Logo134x64:
      "/assets/img/University_logo/ECA/SWINBURNE_UNIVERSITY_OF_TECHNOLOGY_Sydney_(ECA).jpg",
    Id: "591",
  },
  {
    Name: "ASIA PACIFIC INTERNATIONAL COLLEGE Sydney, Melbourne, Brisbane (ECA)",
    Logo134x64:
      "/assets/img/University_logo/ECA/ASIA_PACIFIC_INTERNATIONAL_COLLEGE_Sydney_(ECA).jpg",
    Id: "1030",
  },
  {
    Name: "COLLEGE OF HEALTH SCIENCES -Sydney, Brisbane (ECA)",
    Logo134x64:
      "/assets/img/University_logo/ECA/COLLEGE_OF_HEALTH_SCIENCES_Sydney(ECA).jpg",
    Id: "1031",
  },
  {
    Name: "HIGHER EDUCATION LEADERSHIP INSTITUTE -Melbourne (ECA)",
    Logo134x64:
      "/assets/img/University_logo/ECA/HIGHER_EDUCATION_LEADERSHIP_INSTITUTE_Melbourne_(ECA).jpg",
    Id: "1032",
  },
];

// export const All_University_Logo = [
//   ...University_Logo_Model,
//   ...University_Logo_Navitas,
//   ...Univeristy_Logo_ECA,
// ];

// export const All_University_Logo= [
//   {
//     Id: 600,
//     Name: "Victoria University - ECA",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/Victoria_University_Sydney.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/victoria_university.png",
//   },
//   {
//     Id: 2,
//     Name: "University of Canberra",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/university_of_canberra.png",
//   },
//   {
//     Id: 30,
//     Name: "University of Tasmania",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/university_of_tasmania.png",
//   },
//   {
//     Id: 24,
//     Name: "University of the Sunshine Coast",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/55x55/University_of_the_Sunshine_Coast.jpg",
//   },
//   {
//     Id: 31,
//     Name: "Deakin University",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/Deakin_University.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/deakin.png",
//   },
//   {
//     Id: 17,
//     Name: "Central Queensland University",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/Central_Queensland_University_(CQU).jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
//   },
//   {
//     Id: 15,
//     Name: "Charles Darwin University",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/Charles_Darwin_University.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/charles_darwin_university.png",
//   },
//   {
//     Id: 13,
//     Name: "Western Sydney University",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/Western_Sydney_University_jpg_1722322153583.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
//   },
//   {
//     Id: 20,
//     Name: "James Cook University",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/James_Cook_University_jpg_1684399152128.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/james_cook_university.png",
//   },
//   {
//     Id: 32,
//     Name: "La Trobe University",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/la_trobe_university.png",
//   },
//   {
//     Id: 698,
//     Name: "Saibt leading to UNISA",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/Saibt_leading_to_UNISA_jpg_1684993343864.jpg",
//     Logo310x125: null,
//   },
//   {
//     Id: 34,
//     Name: "RMIT University",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/rmit_university.png",
//   },
//   {
//     Id: 6,
//     Name: "Macquarie University",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/macquarie_university.png",
//   },
//   {
//     Id: 12,
//     Name: "University of Technology, Sydney",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/university_of_technology,_sydney.png",
//   },
//   {
//     Id: 35,
//     Name: "Swinburne University of Technology",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/Swinburne_University_Sydney_jpg_1685011493556.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/swinburne_university_of_technology.png",
//   },
//   {
//     Id: 37,
//     Name: "University of Melbourne",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/university_of_melbourne.png",
//   },
//   {
//     Id: 1,
//     Name: "Australian National University",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/Australian_National_University_3_jpg_1701752329401.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/australian_national_university.png",
//   },
//   {
//     Id: 11,
//     Name: "University of Sydney",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/university_of_sydney.png",
//   },
//   {
//     Id: 22,
//     Name: "University of Queensland",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/university_of_queensland.png",
//   },
//   {
//     Id: 43,
//     Name: "University of Western Australia",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/university_of_western_australia.png",
//   },
//   {
//     Id: 28,
//     Name: "University of Adelaide",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/university_of_adelaide.png",
//   },
//   {
//     Id: 33,
//     Name: "Monash University",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/Monash-University.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/monash_university.png",
//   },
//   {
//     Id: 9,
//     Name: "University of New South Wales",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/University-of-New-South-Wales.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/university_of_new_south_wales.png",
//   },
//   {
//     Id: 245,
//     Name: "London Metropolitan University ",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/London_Metropolitan_University_jpg_1684230530518.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
//   },
//   {
//     Id: 288,
//     Name: "University of Northampton ",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/University-of-Northampton.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
//   },
//   {
//     Id: 202,
//     Name: "Heriot-Watt University ",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/_1683545505026.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
//   },
//   {
//     Id: 744,
//     Name: "Stanley College",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/Stanley_College_jpg_1685009088167.jpg",
//     Logo310x125: null,
//   },
//   {
//     Id: 432,
//     Name: "University of South Wales",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/University_of_South_Wales_jpg_1686808887049.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
//   },
//   {
//     Id: 149,
//     Name: "Coventry University ",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/55x55/Coventry_University.jpg",
//   },
//   {
//     Id: 362,
//     Name: "University of Surrey ",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/University_of_Surrey_jpg_1686809895078.jpg",
//     Logo310x125:
//       "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
//   },
//   {
//     Id: 662,
//     Name: "The University of Law",
//     Logo134x64: null,
//     Logo310x125:
//       "https://doc.searcheducation.in/university/55x55/University_Of_Law.jpg",
//   },
// ];

// export const All_University_Logo = [
//   {
//     Name: "Australian Institute of Music",
//     Logo134x64: "/assets/img/University_Logo/Australian_Institute_of_Music.jpg",
//     Id: "48",
//   },
//   {
//     Name: "Heriot Watt University",
//     Logo134x64: "/assets/img/University_Logo/Heriot_Watt_University.jpg",
//     Id: "589",
//   },
//   {
//     Name: "GBS Malta",
//     Logo134x64: "/assets/Global_Fair/26.jpg",
//     Id: "952",
//   },
//   {
//     Name: "GBS Dubai",
//     Logo134x64: "/assets/Global_Fair/30.jpg",
//     Id: "976",
//   },
//   {
//     Name: "BSBI – Berlin School of Business and Innovation",
//     Logo134x64: "/assets/img/University_Logo/BSBI.png",
//     Id: "728",
//   },
//   {
//     Name: "Business and Hotel Management School - BHMS",
//     Logo134x64: "/assets/img/University_Logo/BHMS.png",
//     Id: "945",
//   },
//   {
//     Name: "Arden University",
//     Logo134x64: "/assets/img/University_Logo/Arden_University.png",
//     Id: "957",
//   },
//   {
//     Name: "Gisma University of Applied Sciences",
//     Logo134x64:
//       "/assets/img/University_Logo/Gisma_University_of_Applied_Sciences.jpg",
//     Id: "956",
//   },
//   {
//     Id: "697",
//     University_Name: "University of Wollongong (Dubai)",
//     Logo134x64: "/assets/Global_Fair/14.jpg",
//   },
//   {
//     Name: "University of Europe for Applied Sciences",
//     Logo134x64:
//       "/assets/img/University_Logo/University_of_Europe_for_Applied_Sciences.jpg",
//     Id: "925",
//   },
//   {
//     Name: "Kingston International College",
//     Logo134x64:
//       "/assets/img/University_Logo/Kingston_International_College.jpg",
//     Id: "1044",
//   },
//   {
//     Name: "Schiller Business school (Gedu)",
//     Logo134x64:
//       "/assets/img/University_Logo/Schiller_Business_school_(Gedu).jpg",
//     Id: "961",
//   },
//   {
//     Name: "BIMM Limited",
//     Logo134x64: "/assets/Global_Fair/3.jpg",
//     Id: 88,
//   },
//   {
//     Id: 1096,
//     Name: "European Institute of Management & Technology (EIMT)",
//     Logo134x64: "/assets/Global_Fair/32.jpg",
//   },
//   {
//     Name: "EU Business School",
//     Id: 725,
//     Logo134x64: "/assets/Global_Fair/35.jpg",
//   },
//   {
//     Id: 1101,
//     Name: "Tio Business School",
//     Logo134x64: "/assets/Global_Fair/36.jpg",
//   },
//   {
//     Id: 408,
//     Name: "Lancaster University",
//     Logo134x64: "/assets/Global_Fair/42.jpg",
//   },
//   {
//     Id: 41,
//     Name: "Murdoch University",
//     Logo134x64: "/assets/Global_Fair/18.jpg",
//   },
//   {
//     Id: 991,
//     Name: "ICN Business School",
//     Logo134x64: "/assets/Global_Fair/24.jpg",
//   },
//   {
//     Id: 1099,
//     Name: "LONDON SCHOOL OF BUSINESS AND FINANCE",
//     Logo134x64: "/assets/Global_Fair/12.jpg",
//   },
//   {
//     Id: 953,
//     Name: "Lyon Institute for Geostrategy & Multi Cultural Relation (LIGMR)",
//     Logo134x64: "/assets/Global_Fair/20.jpg",
//   },

//   {
//     Id: 1045,
//     Name: "Singapore Raffles Music College (SRMC)",
//     Logo134x64: "/assets/Global_Fair/5.jpg",
//   },
//   {
//     Id: 865,
//     Name: "Britts Imperial University College ",
//     Logo134x64: "/assets/Global_Fair/13.jpg",
//   },
//   {
//     Id: 955,
//     Name: "Steinbeis University",
//     Logo134x64: "/assets/Global_Fair/21.jpg",
//   },
//   {
//     Id: 729,
//     Name: "International School of Management",
//     Logo134x64: "/assets/Global_Fair/22.jpg",
//   },
//   {
//     Id: 1102,
//     Name: "ISTEC BUSINESS SCHOOL",
//     Logo134x64: "/assets/Global_Fair/31.jpg",
//   },
//   {
//     Id: 574,
//     Name: "St. Stephen's University",
//     Logo134x64: "/assets/Global_Fair/33.jpg",
//   },
//   {
//     Id: 1103,
//     Name: "ISC Paris",
//     Logo134x64: "/assets/Global_Fair/39.jpg",
//   },
//   {
//     Id: 600,
//     Name: "Victoria University - ECA",
//     Logo134x64:
//       "/assets/img/University_logo/ECA/VICTORIA_UNIVERSITY_SYDNEY_(ECA).jpg",
//   },

//   {
//     Id: 2,
//     Name: "University of Canberra",
//     Logo134x64: "/assets/img/Logo_114/University_of_Canberra.jpg",
//   },

//   {
//     Id: 30,
//     Name: "University of Tasmania",
//     Logo134x64: "/assets/img/Logo_114/University_of_Tasmania.jpg",
//   },

//   {
//     Id: 24,
//     Name: "University of the Sunshine Coast",
//     Logo134x64: "/assets/img/Logo_114/University_of_the_Sunshine_Coast.jpg",
//   },
//   {
//     Id: 31,
//     Name: "Deakin University",
//     Logo134x64: "/assets/img/University_logo/Deakin_University.jpg",
//   },
//   {
//     Id: 17,
//     Name: "Central Queensland University",
//     Logo134x64: "/assets/img/University_logo/CQU.jpg",
//   },
//   {
//     Id: 15,
//     Name: "Charles Darwin University",
//     Logo134x64: "/assets/img/Logo_114/Charles_Darwin_University.jpg",
//   },
//   {
//     Id: 13,
//     Name: "Western Sydney University",
//     Logo134x64: "/assets/img/Logo_114/Western_Sydney_University.jpg",
//   },
//   {
//     Id: 20,
//     Name: "James Cook University",
//     Logo134x64: "/assets/img/University_logo/James_Cook_University.jpg",
//   },

//   {
//     Id: 32,
//     Name: "La Trobe University",

//     Logo134x64: "/assets/img/Logo_114/La_Trobe_University.jpg",
//   },
//   {
//     Id: 149,
//     Name: "Coventry University ",

//     Logo134x64:
//       "https://doc.searcheducation.in/university/55x55/Coventry_University.jpg",
//   },

//   {
//     Id: 34,
//     Name: "RMIT University",
//     Logo134x64: "/assets/img/Logo_114/RMIT_University.jpg",
//   },
//   {
//     Id: 6,
//     Name: "Macquarie University",
//     Logo134x64: null,
//     Logo134x64:
//       "https://doc.searcheducation.in/university/310x125/macquarie_university.png",
//   },
//   {
//     Id: 12,
//     Name: "University of Technology, Sydney",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/310x125/university_of_technology,_sydney.png",
//   },
//   {
//     Id: 35,
//     Name: "Swinburne University of Technology",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/310x125/swinburne_university_of_technology.png",
//   },
//   {
//     Id: 37,
//     Name: "University of Melbourne",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/310x125/university_of_melbourne.png",
//   },
//   {
//     Id: 1,
//     Name: "Australian National University",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/310x125/australian_national_university.png",
//   },
//   {
//     Id: 11,
//     Name: "University of Sydney",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/310x125/university_of_sydney.png",
//   },
//   {
//     Id: 22,
//     Name: "University of Queensland",
//     Logo134x64: null,

//     Logo134x64:
//       "https://doc.searcheducation.in/university/310x125/university_of_queensland.png",
//   },
//   {
//     Id: 43,
//     Name: "University of Western Australia",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/310x125/university_of_western_australia.png",
//   },
//   {
//     Id: 28,
//     Name: "University of Adelaide",

//     Logo134x64:
//       "https://doc.searcheducation.in/university/310x125/university_of_adelaide.png",
//   },
//   {
//     Id: 33,
//     Name: "Monash University",

//     Logo134x64:
//       "https://doc.searcheducation.in/university/310x125/monash_university.png",
//   },

//   {
//     Id: 9,
//     Name: "University of New South Wales",

//     Logo134x64:
//       "https://doc.searcheducation.in/university/310x125/university_of_new_south_wales.png",
//   },
//   {
//     Id: 245,
//     Name: "London Metropolitan University ",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/London_Metropolitan_University_jpg_1684230530518.jpg",
//   },
//   {
//     Id: 288,
//     Name: "University of Northampton ",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/University-of-Northampton.jpg",
//   },
//   {
//     Id: 202,
//     Name: "Heriot-Watt University ",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/_1683545505026.jpg",
//   },
//   {
//     Id: 744,
//     Name: "Stanley College",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/Stanley_College_jpg_1685009088167.jpg",
//   },
//   {
//     Id: 432,
//     Name: "University of South Wales",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/University_of_South_Wales_jpg_1686808887049.jpg",
//   },
//   {
//     Id: 698,
//     Name: "Saibt leading to UNISA",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/Saibt_leading_to_UNISA_jpg_1684993343864.jpg",
//   },

//   {
//     Id: 362,
//     Name: "University of Surrey ",
//     Logo134x64:
//       "https://doc.searcheducation.in/university/Logo134x64/University_of_Surrey_jpg_1686809895078.jpg",
//   },
//   {
//     Id: 662,
//     Name: "The University of Law",

//     Logo134x64:
//       "https://doc.searcheducation.in/university/55x55/University_Of_Law.jpg",
//   },
// ];

export const All_University_Logo = [
  {
    Id: 600,
    Name: "Victoria University - ECA",
    Logo: "/assets/img/University_logo/ECA/VICTORIA_UNIVERSITY_SYDNEY_(ECA).jpg",
    Logo134x64:
      "/assets/img/University_logo/ECA/VICTORIA_UNIVERSITY_SYDNEY_(ECA).jpg",
  },
  {
    Id: 2,
    Name: "University of Canberra",
    Logo: "/assets/img/Logo_114/University_of_Canberra.jpg",
    Logo134x64: "/assets/img/Logo_114/University_of_Canberra.jpg",
  },
  {
    Id: 30,
    Name: "University of Tasmania",
    Logo: "/assets/img/Logo_114/University_of_Tasmania.jpg",
    Logo134x64: "/assets/img/Logo_114/University_of_Tasmania.jpg",
  },
  {
    Id: 24,
    Name: "University of the Sunshine Coast",
    Logo: "/assets/img/Logo_114/University_of_the_Sunshine_Coast.jpg",
    Logo134x64: "/assets/img/Logo_114/University_of_the_Sunshine_Coast.jpg",
  },
  {
    Id: 31,
    Name: "Deakin University",
    Logo: "/assets/img/University_logo/Deakin_University.jpg",
    Logo134x64: "/assets/img/University_logo/Deakin_University.jpg",
  },
  {
    Id: 17,
    Name: "Central Queensland University",
    Logo: "/assets/img/University_logo/CQU.jpg",
    Logo134x64: "/assets/img/University_logo/CQU.jpg",
  },
  {
    Id: 15,
    Name: "Charles Darwin University",
    Logo: "/assets/img/Logo_114/Charles_Darwin_University.jpg",
    Logo134x64: "/assets/img/Logo_114/Charles_Darwin_University.jpg",
  },
  {
    Id: 13,
    Name: "Western Sydney University",
    Logo: "/assets/img/Logo_114/Western_Sydney_University.jpg",
    Logo134x64: "/assets/img/Logo_114/Western_Sydney_University.jpg",
  },
  {
    Id: 20,
    Name: "James Cook University",
    Logo: "/assets/img/University_logo/James_Cook_University.jpg",
    Logo134x64: "/assets/img/University_logo/James_Cook_University.jpg",
  },
  {
    Id: 32,
    Name: "La Trobe University",
    Logo: "/assets/img/Logo_114/La_Trobe_University.jpg",
    Logo134x64: "/assets/img/Logo_114/La_Trobe_University.jpg",
  },
  {
    Id: 149,
    Name: "Coventry University ",
    Logo: "https://doc.searcheducation.in/university/55x55/Coventry_University.jpg",
    Logo134x64:
      "https://doc.searcheducation.in/university/55x55/Coventry_University.jpg",
  },
  {
    Id: 34,
    Name: "RMIT University",
    Logo: "/assets/img/Logo_114/RMIT_University.jpg",
    Logo134x64: "/assets/img/Logo_114/RMIT_University.jpg",
  },
  {
    Id: 6,
    Name: "Macquarie University",
    Logo134x64:
      "https://doc.searcheducation.in/university/310x125/macquarie_university.png",
    Logo: "https://doc.searcheducation.in/university/310x125/macquarie_university.png",
  },
  {
    Id: 12,
    Name: "University of Technology, Sydney",
    Logo: "https://doc.searcheducation.in/university/310x125/university_of_technology,_sydney.png",
    Logo134x64:
      "https://doc.searcheducation.in/university/310x125/university_of_technology,_sydney.png",
  },
  {
    Id: 35,
    Name: "Swinburne University of Technology",
    Logo: "https://doc.searcheducation.in/university/310x125/swinburne_university_of_technology.png",
    Logo134x64:
      "https://doc.searcheducation.in/university/310x125/swinburne_university_of_technology.png",
  },
  {
    Id: 37,
    Name: "University of Melbourne",
    Logo: "https://doc.searcheducation.in/university/310x125/university_of_melbourne.png",
    Logo134x64:
      "https://doc.searcheducation.in/university/310x125/university_of_melbourne.png",
  },
  {
    Id: 1,
    Name: "Australian National University",
    Logo: "https://doc.searcheducation.in/university/310x125/australian_national_university.png",
    Logo134x64:
      "https://doc.searcheducation.in/university/310x125/australian_national_university.png",
  },
  {
    Id: 11,
    Name: "University of Sydney",
    Logo: "https://doc.searcheducation.in/university/310x125/university_of_sydney.png",
    Logo134x64:
      "https://doc.searcheducation.in/university/310x125/university_of_sydney.png",
  },
  {
    Id: 22,
    Name: "University of Queensland",
    Logo134x64:
      "https://doc.searcheducation.in/university/310x125/university_of_queensland.png",
    Logo: "https://doc.searcheducation.in/university/310x125/university_of_queensland.png",
  },
  {
    Id: 43,
    Name: "University of Western Australia",
    Logo: "https://doc.searcheducation.in/university/310x125/university_of_western_australia.png",
    Logo134x64:
      "https://doc.searcheducation.in/university/310x125/university_of_western_australia.png",
  },
  {
    Id: 28,
    Name: "University of Adelaide",
    Logo: "https://doc.searcheducation.in/university/310x125/university_of_adelaide.png",
    Logo134x64:
      "https://doc.searcheducation.in/university/310x125/university_of_adelaide.png",
  },
  {
    Id: 33,
    Name: "Monash University",
    Logo: "https://doc.searcheducation.in/university/310x125/monash_university.png",
    Logo134x64:
      "https://doc.searcheducation.in/university/310x125/monash_university.png",
  },
  {
    Id: 9,
    Name: "University of New South Wales",
    Logo: "https://doc.searcheducation.in/university/310x125/university_of_new_south_wales.png",
    Logo134x64:
      "https://doc.searcheducation.in/university/310x125/university_of_new_south_wales.png",
  },
  {
    Id: 245,
    Name: "London Metropolitan University ",
    Logo: "https://doc.searcheducation.in/university/Logo134x64/London_Metropolitan_University_jpg_1684230530518.jpg",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/London_Metropolitan_University_jpg_1684230530518.jpg",
  },
  {
    Id: 288,
    Name: "University of Northampton ",
    Logo: "https://doc.searcheducation.in/university/Logo134x64/University-of-Northampton.jpg",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/University-of-Northampton.jpg",
  },
  {
    Id: 202,
    Name: "Heriot-Watt University ",
    Logo: "https://doc.searcheducation.in/university/Logo134x64/_1683545505026.jpg",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/_1683545505026.jpg",
  },
  {
    Id: 744,
    Name: "Stanley College",
    Logo: "https://doc.searcheducation.in/university/Logo134x64/Stanley_College_jpg_1685009088167.jpg",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/Stanley_College_jpg_1685009088167.jpg",
  },
  {
    Id: 432,
    Name: "University of South Wales",
    Logo: "https://doc.searcheducation.in/university/Logo134x64/University_of_South_Wales_jpg_1686808887049.jpg",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/University_of_South_Wales_jpg_1686808887049.jpg",
  },
  {
    Id: 698,
    Name: "Saibt leading to UNISA",
    Logo: "https://doc.searcheducation.in/university/Logo134x64/Saibt_leading_to_UNISA_jpg_1684993343864.jpg",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/Saibt_leading_to_UNISA_jpg_1684993343864.jpg",
  },
  {
    Id: 362,
    Name: "University of Surrey ",
    Logo: "https://doc.searcheducation.in/university/Logo134x64/University_of_Surrey_jpg_1686809895078.jpg",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/University_of_Surrey_jpg_1686809895078.jpg",
  },
  {
    Id: 662,
    Name: "The University of Law",
    Logo: "https://doc.searcheducation.in/university/55x55/University_Of_Law.jpg",
    Logo134x64:
      "https://doc.searcheducation.in/university/55x55/University_Of_Law.jpg",
  },
  {
    Name: "Abertay University",
    Logo: "/assets/img/University_Logo/Abertay_University.jpg",
    Id: "60",
    Logo134x64: "/assets/img/University_Logo/Abertay_University.jpg",
  },
  {
    Name: "Arden University",
    Logo: "/assets/img/University_Logo/Arden_University.png",
    Id: "957",
    Logo134x64: "/assets/img/University_Logo/Arden_University.png",
  },
  {
    Name: "Australian Institute of Music",
    Logo: "/assets/img/University_Logo/Australian_Institute_of_Music.jpg",
    Id: "48",
    Logo134x64: "/assets/img/University_Logo/Australian_Institute_of_Music.jpg",
  },
  {
    Name: "BSBI – Berlin School of Business and Innovation",
    Logo: "/assets/img/University_Logo/BSBI.png",
    Id: "728",
    Logo134x64: "/assets/img/University_Logo/BSBI.png",
  },
  {
    Name: "Business and Hotel Management School - BHMS",
    Logo: "/assets/img/University_Logo/BHMS.png",
    Id: "945",
    Logo134x64: "/assets/img/University_Logo/BHMS.png",
  },
  {
    Name: "Charles Sturt University",
    Logo: "/assets/img/University_Logo/Charles_Sturt_University.jpg",
    Id: "5",
    Logo134x64: "/assets/img/University_Logo/Charles_Sturt_University.jpg",
  },
  {
    Name: "Ema(Gedu)",
    Logo: "/assets/img/University_Logo/Ema(Gedu).jpg",
    Id: "1034",
    Logo134x64: "/assets/img/University_Logo/Ema(Gedu).jpg",
  },
  {
    Name: "Gisma University of Applied Sciences",
    Logo: "/assets/img/University_Logo/Gisma_University_of_Applied_Sciences.jpg",
    Id: "956",
    Logo134x64:
      "/assets/img/University_Logo/Gisma_University_of_Applied_Sciences.jpg",
  },
  {
    Name: "GBS Malta (Gedu)",
    Logo: "/assets/img/University_Logo/GBS_Malta(Gedu).jpg",
    Id: "1035",
    Logo134x64: "/assets/img/University_Logo/GBS_Malta(Gedu).jpg",
  },
  {
    Name: "GBS Dubai (Gedu)",
    Logo: "/assets/img/University_Logo/GBS_Dubai(Gedu).jpg",
    Id: "1036",
    Logo134x64: "/assets/img/University_Logo/GBS_Dubai(Gedu).jpg",
  },
  {
    Name: "Harper Adams University",
    Logo: "/assets/img/University_Logo/Harper_Adams_University.jpg",
    Id: "196",
    Logo134x64: "/assets/img/University_Logo/Harper_Adams_University.jpg",
  },
  {
    Name: "Heriot Watt University",
    Logo: "/assets/img/University_Logo/Heriot_Watt_University.jpg",
    Id: "589",
    Logo134x64: "/assets/img/University_Logo/Heriot_Watt_University.jpg",
  },
  {
    Name: "Kaplan Business School",
    Logo: "/assets/img/University_Logo/Kaplan_Business_School.jpg",
    Id: "660",
    Logo134x64: "/assets/img/University_Logo/Kaplan_Business_School.jpg",
  },
  {
    Name: "Schiller Business school (Gedu)",
    Logo: "/assets/img/University_Logo/Schiller_Business_school_(Gedu).jpg",
    Id: "961",
    Logo134x64:
      "/assets/img/University_Logo/Schiller_Business_school_(Gedu).jpg",
  },
  {
    Name: "Trinity Western University",
    Logo: "/assets/img/University_Logo/Trinity_Western_University.jpg",
    Id: "524",
    Logo134x64: "/assets/img/University_Logo/Trinity_Western_University.jpg",
  },
  {
    Name: "University of Europe for Applied Sciences",
    Logo: "/assets/img/University_Logo/University_of_Europe_for_Applied_Sciences.jpg",
    Id: "925",
    Logo134x64:
      "/assets/img/University_Logo/University_of_Europe_for_Applied_Sciences.jpg",
  },
  {
    Name: "University of Hull - London",
    Logo: "/assets/img/University_Logo/University_of_Hull.jpg",
    Id: "210",
    Logo134x64: "/assets/img/University_Logo/University_of_Hull.jpg",
  },
  {
    Name: "Singapore Raffles Music College (SRMC)",
    Logo: "/assets/img/University_Logo/Singapore_Raffles_Music_College_ (SRMC).jpg",
    Id: "1045",
    Logo134x64:
      "/assets/img/University_Logo/Singapore_Raffles_Music_College_ (SRMC).jpg",
  },
  {
    Name: "Kingston International College",
    Logo: "/assets/img/University_Logo/Kingston_International_College.jpg",
    Id: "1044",
    Logo134x64:
      "/assets/img/University_Logo/Kingston_International_College.jpg",
  },
  {
    Name: "UNIVERSITY OF SUNSHINE COAST -Adelaide (ECA)",
    Logo: "/assets/img/University_logo/ECA/UNIVERSITY_OF_SUNSHINE_COAST_Adelaide_(ECA).jpg",
    Id: "1037",
    Logo134x64:
      "/assets/img/University_logo/ECA/UNIVERSITY_OF_SUNSHINE_COAST_Adelaide_(ECA).jpg",
  },
  {
    Name: "UNIVERSITY OF TASMANIA -Melbourne, Sydney (ECA)",
    Logo: "/assets/img/University_logo/ECA/UNIVERSITY_OF_TASMANIA_Melbourne_Sydney_(ECA).jpg",
    Id: "903",
    Logo134x64:
      "/assets/img/University_logo/ECA/UNIVERSITY_OF_TASMANIA_Melbourne_Sydney_(ECA).jpg",
  },
  {
    Name: "SWINBURNE UNIVERSITY OF TECHNOLOGY - Sydney (ECA)",
    Logo: "/assets/img/University_logo/ECA/SWINBURNE_UNIVERSITY_OF_TECHNOLOGY_Sydney_(ECA).jpg",
    Id: "591",
    Logo134x64:
      "/assets/img/University_logo/ECA/SWINBURNE_UNIVERSITY_OF_TECHNOLOGY_Sydney_(ECA).jpg",
  },
  {
    Name: "ASIA PACIFIC INTERNATIONAL COLLEGE Sydney, Melbourne, Brisbane (ECA)",
    Logo: "/assets/img/University_logo/ECA/ASIA_PACIFIC_INTERNATIONAL_COLLEGE_Sydney_(ECA).jpg",
    Id: "1030",
    Logo134x64:
      "/assets/img/University_logo/ECA/ASIA_PACIFIC_INTERNATIONAL_COLLEGE_Sydney_(ECA).jpg",
  },
  {
    Name: "COLLEGE OF HEALTH SCIENCES -Sydney, Brisbane (ECA)",
    Logo: "/assets/img/University_logo/ECA/COLLEGE_OF_HEALTH_SCIENCES_Sydney(ECA).jpg",
    Id: "1031",
    Logo134x64:
      "/assets/img/University_logo/ECA/COLLEGE_OF_HEALTH_SCIENCES_Sydney(ECA).jpg",
  },
  {
    Name: "HIGHER EDUCATION LEADERSHIP INSTITUTE -Melbourne (ECA)",
    Logo: "/assets/img/University_logo/ECA/HIGHER_EDUCATION_LEADERSHIP_INSTITUTE_Melbourne_(ECA).jpg",
    Id: "1032",
    Logo134x64:
      "/assets/img/University_logo/ECA/HIGHER_EDUCATION_LEADERSHIP_INSTITUTE_Melbourne_(ECA).jpg",
  },
  {
    Name: "Charles Sturt University (Navitas) ",
    Logo: "/assets/img/University_logo/Navitas/CSU_Navitas.jpg",
    Id: "1043",
    Logo134x64: "/assets/img/University_logo/Navitas/CSU_Navitas.jpg",
  },
  {
    Name: "Western Sydney University (Navitas)",
    Logo: "/assets/img/University_logo/Navitas/Western_Sydney_University_Navitas.jpg",
    Id: "1022",
    Logo134x64:
      "/assets/img/University_logo/Navitas/Western_Sydney_University_Navitas.jpg",
  },
  {
    Name: "GBS Malta",
    Logo: "/assets/Global_Fair/26.jpg",
    Id: "952",
    Logo134x64: "/assets/Global_Fair/26.jpg",
  },
  {
    Name: "GBS Dubai",
    Logo: "/assets/Global_Fair/30.jpg",
    Id: "976",
    Logo134x64: "/assets/Global_Fair/30.jpg",
  },
  {
    Id: 219,
    Name: "University of Kent International College",
    Logo: "/assets/img/University_logo/Univeristy_of_kent.jpg",
    Logo134x64: "/assets/img/University_logo/Univeristy_of_kent.jpg",
  },
  {
    Id: 106,
    Name: "Univeristy of Bradford International College",
    Logo: "/assets/img/University_Logo/University_Of_Bradford.jpg",
    Logo134x64: "/assets/img/University_Logo/University_Of_Bradford.jpg",
  },
  {
    Id: 81,
    Name: "Bangor University International College",
    Logo: "/assets/img/University_Logo/Bangor_Univeristy.jpg",
    Logo134x64: "/assets/img/University_Logo/Bangor_Univeristy.jpg",
  },
  {
    Name: "De Mont Fort University International College",
    Logo: "/assets/img/University_logo/De_Montfort_University.jpg",
    Id: "155",
    Logo134x64: "/assets/img/University_logo/De_Montfort_University.jpg",
  },
  {
    Name: "Hult International Business School",
    Logo: "/assets/img/University_logo/Hult_International.jpg",
    Id: "1092",
    Logo134x64: "/assets/img/University_logo/Hult_International.jpg",
  },
  {
    Name: "International College Dundee",
    Logo: "/assets/img/University_logo/International_College_Dundee.jpg",
    Id: "160",
    Logo134x64: "/assets/img/University_logo/International_College_Dundee.jpg",
  },
  {
    Id: 431,
    Name: "Edinburgh Napier University International College",
    Logo: "/assets/img/University_logo/Napier_University.jpg",
    Logo134x64: "/assets/img/University_logo/Napier_University.jpg",
  },
  {
    Id: 1020,
    Name: "Sydney Institute of Business & Technology - Sibt (Navitas)",
    Logo: "/assets/img/University_logo/Sibt_navitas.jpg",
    Logo134x64: "/assets/img/University_logo/Sibt_navitas.jpg",
  },
  {
    Id: 190,
    Name: "University of Greenwich International College",
    Logo: "/assets/img/University_logo/University_Of_Greenwich.jpg",
    Logo134x64: "/assets/img/University_logo/University_Of_Greenwich.jpg",
  },
];
